<template>
	<page @click="() => (batchSetData = '', editImage = '')">
		<module :title="id ? (view?'商品详情':'编辑商品' ): '发布商品'" :sub-title="compClassifyName">
			<c-form ref="form" unit-width="500">
				<c-form-item label="商品标题" width="800" required>
					<c-input name="product_name" :disabled="view"></c-input>
				</c-form-item>
				<c-form-item label="商品卖点" width="800" >
					<c-input name="product_subtitle" :disabled="view"></c-input>
				</c-form-item>
				<c-form-item label="商品货号" width="300" :required="systemConfig.product_number_required == 'ON' || systemConfig.product_sku_code_autocreate_type == 'productnumberseq'">
					<c-input name="product_itemnumber" :disabled="view"></c-input>
				</c-form-item>
				<c-form-item label="商品品牌">
					<c-select name="product_brand_id" options="BRAND_LIST" :disabled="view"></c-select>
				</c-form-item>
                <c-form-item label="卡券有效期" v-show="isVirtual==1" width="300" tip="下单支付后，自动生成的消费卡券在该期限内有效，超期则自动失效" required>
                    <c-input type="number" decimal="0" :range="[1,9999]" v-model="effectiveMonths"
                             name="effective_months" unit="月"></c-input>
                </c-form-item>
                <c-form-item label="超期未消费" v-show="isVirtual==1" width="300" tip="卡券超期时效后是否退还购买卡券的金额（注：该配置在产生卡券时即固定，修改配置对已生成的卡券无效）" required>
                    <c-radio-group name="expire_card_refund" v-model="expireCardRefund" :options="expireCardRefundOption" ></c-radio-group>
                </c-form-item>

				<c-form-item v-show="attrConfig.length" label="商品属性" width="1000">
					<div class="box params">
						<c-form ref="attrForm" column="2" name="product_attr_list" style="padding: 0;">
							<c-form-item v-for="(item, i) in attrConfig" :key="i" :label="item.parameter_name" :required="item.required_flag == 2">
								<c-input v-if="item.parameter_type == 'input'" :name="item.id.toString()" :disabled="view"></c-input>
								<c-select v-else-if="item.parameter_type == 'select'" :name="item.id.toString()" :options="item.parameter_values" :disabled="view"></c-select>
								<c-radio-group v-else-if="item.parameter_type == 'radio'" :name="item.id.toString()" :options="item.parameter_values" :disabled="view"></c-radio-group>
								<c-checkbox-group v-else-if="item.parameter_type == 'checkbox'" :name="item.id.toString()" :options="item.parameter_values" :disabled="view"></c-checkbox-group>
							</c-form-item>
						</c-form>
					</div>
				</c-form-item>
				<c-form-item v-show="paramConfig.length" label="商品参数" width="1000">
					<div class="box params">
						<c-form ref="paramForm" column="2" name="product_paramter_list" style="padding: 0;">
							<c-form-item v-for="(item, i) in paramConfig" :key="i" :label="item.parameter_name" :required="item.required_flag == 2">
								<c-input v-if="item.parameter_type == 'input'" :name="item.id.toString()" :disabled="view"></c-input>
								<c-select v-else-if="item.parameter_type == 'select'" :name="item.id.toString()" :options="item.parameter_values" :disabled="view"></c-select>
								<c-radio-group v-else-if="item.parameter_type == 'radio'" :name="item.id.toString()" :options="item.parameter_values" :disabled="view"></c-radio-group>
								<c-checkbox-group v-else-if="item.parameter_type == 'checkbox'" :name="item.id.toString()" :options="item.parameter_values" :disabled="view"></c-checkbox-group>
							</c-form-item>
						</c-form>
					</div>
				</c-form-item>
				<c-form-item label="商品主图" required width="800">
					<c-radio-group v-model="imageScale" name="product_img_type" style="margin-bottom: 10px;" :disabled="view">
						<c-radio value="2">1:1</c-radio>
						<c-radio value="1">3:4</c-radio>
					</c-radio-group>
					<c-upload-file name="product_img_list" media multiple="5" type="image" :tip="`主图大小不能超过3MB，建议尺寸${imageScale == 1 ? '750x1000' : '800x800'}`" @click="$selectFile" ></c-upload-file>
				</c-form-item>
				<c-form-item v-show="imageScale == 1" label="1:1主图" required width="800">
					<c-upload-file name="product_square_img" media type="image" tip="请上传一张1:1主图，将显示在商品列表、收藏夹及历史足迹等页面" @click="$selectFile"></c-upload-file>
				</c-form-item>
				<c-form-item label="商品视频" width="800">
					<c-upload-file name="product_video_url" media type="video" tip="视频支持1:1、16:9，最长不超过60秒，突出1-2个核心卖点；文件大小不超过30M" @click="$selectFile"></c-upload-file>
				</c-form-item>
				<c-form-item label="商品描述" width="1000">
					<div class="box detail flex">
						<dl class="detail-preview">
							<dt>页面预览</dt>
							<dd>
								<template v-for="(item, i) in detailList">
									<img v-if="item.type == 'image'" :key="i" :src="item.content">
									<div v-else :key="i">{{item.content}}</div>
								</template>
							</dd>
						</dl>
						<div class="detail-edit flex-grow" v-if="!view">
							<p class="tips">支持图片和文本，最多可插入50条内容，已插入<b>{{detailList.length}}</b>/50条，拖拽可调整顺序</p>
							<div class="flex-wrap">
								<c-drag-sort v-model="detailList" class="flex-wrap">
								    <template v-slot="{item, id, index}">
								        <c-drag-item :key="id" :index="index">
											<div class="detail-edit-item flex-center">
												<img v-if="item.type == 'image'" :src="item.content">
												<div v-else class="text">
													<p>{{item.content}}</p>
												</div>
												<div class="handle flex" @mousedown.stop>
													<a v-if="item.type == 'text'" style="background: #0060EF;" @click="insertDetailItem('text', item, index)"><i class="tf tf-edit"></i></a>
													<a style="background: #F30000;" @click="delDetailItem(index)"><i class="tf tf-cross"></i></a>
												</div>
											</div>
								        </c-drag-item>
								    </template>
									<div slot="append" class="detail-edit-item insert flex-column flex-center-main">
										<c-button @click="insertDetailItem('image')" :disabled="view">插入图片</c-button>
										<c-button @click="insertDetailItem('text')" :disabled="view">插入文本</c-button>
									</div>
								</c-drag-sort>
							</div>
						</div>
					</div>
				</c-form-item>
				
				<c-form-item label="尺码信息" width="800">
					<c-upload-file name="product_size_img" media type="image" tip="商品尺码表建议：图片宽度750，高度自定义背景干净整洁，浅色背景，文字信息需要在手机端能够看清楚" @click="$selectFile"></c-upload-file>
				</c-form-item>
				
				<c-form-item v-if="!singleSkuMode" label="SKU配置" required :inline-word="false" width="1000">
					<div class="spec-list">
						<div v-for="(spec, i) in specList" :key="i" class="box spec">
							<div class="flex-center-cross">
								<span class="spec-name">{{spec.name}}</span>
							</div>
							<div class="spec-item-list">
								<c-drag-sort v-model="spec.itemList" class="flex-wrap">
								    <template v-slot="{item, id, index}">
								        <c-drag-item :key="id" :index="index" style="margin: 12px 32px 0 0;">
											<div class="spec-item flex-center-cross">
												<template v-if="spec.image">
													<div v-for="(img, k) in specData[item.id].image" :key="k" class="spec-item-img" :style="{'z-index': editImage == img ? 2 : 1}" @click.stop @mouseenter="editImage = img">
														<div class="main flex-center" @click="delSpecItemImage(item, k)">
															<img :src="img.img" alt="">
															<p class="ellipsis">{{img.name}}</p>
															<a class="delete flex-center"><i class="tf tf-cross"></i></a>
														</div>
														<div v-show="editImage == img" class="preview-box">
															<div class="preview">
																<c-file class="image" :src="img.img" media></c-file>
																<c-input v-model="img.name" class="input" maxlength="6" placeholder="图片描述(最多6个字)" :disabled="view"></c-input>
															</div>
														</div>
													</div>
													<div v-if="specData[item.id].image.length < 5" class="spec-item-img">
														<div class="main flex-center" @click="setSpecItemImage(item)">
															<i class="tf tf-plus"></i>
														</div>
													</div>
												</template>
												<input v-model="specData[item.id].value" class="spec-item-value flex-grow" type="text" @change="specValueVerify(item.id, spec.itemList)" :disabled="view">
												<a v-show="spec.itemList.length > 1" class="spec-item-remove tf tf-clear" @click="removeItem(spec, index)"></a>
											</div>
											
											<c-drag-handle v-if="!view" class="spec-item-drag">
												<div><i class="tf">&#xe688;</i></div>
											</c-drag-handle>
								        </c-drag-item>
								    </template>
								</c-drag-sort>
							</div>
							<c-button background="#4A528D" prepend-icon="tf tf-plus" @click="addSpecItem(spec)"  v-show="!view">添加规格值</c-button>
							<a v-if="spec.new" v-show="specList.length > 1" class="spec-remove" @click="removeSpec(i)"><i class="tf tf-trash"></i></a>
						</div>
					</div>
				</c-form-item>
				
				<c-form-item label="SKU编码" required :word="systemConfig.order_push_enabled == 'ON' ? '当前商档将自动推送第三方' : ''">
					<c-radio-group v-model="currentSkuCode" name="product_sku_code_create_type" :disabled="!!id || view">
						<c-radio value="1">自动生成</c-radio>
						<c-radio value="2">手动填写</c-radio>
					</c-radio-group>
				</c-form-item>
				
				<c-form-item v-if="!singleSkuMode" label="价格及库存" required width="1000">
					<div class="sku-detail">
						<table class="detail-table">
							<thead>
								<tr>
									<th v-for="(spec, i) in specList" :key="i">{{spec.name}}</th>
									<th><b>*</b>报价(元)<a v-if="!view" @click.stop="batchSetSku('cost_price', '报价', $event)"><i class="tf tf-edit"></i></a></th>
									<th><b>*</b>库存(件)<a v-if="!view" @click.stop="batchSetSku('stock', '库存', $event)"><i class="tf tf-edit"></i></a></th>
									<th>官方指导价<a @click.stop="batchSetSku('oldPrice', '官方指导价', $event)"><i class="tf tf-edit"></i></a></th>
									<th v-if="skuPrivateImage">预览图</th>
									<th>重量(kg)<a v-if="!view" @click.stop="batchSetSku('weight', '重量', $event)"><i class="tf tf-edit"></i></a></th>
									<th style="width:160px;"><b>*</b>SKU编码{{currentSkuCode == 1 ? '（自动生成）' : ''}}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-if="skuList.length == 0">
									<td :colspan="specList.length + 6">暂无规格信息</td>
								</tr>
								<template v-else>
									<tr v-for="(row, i) in skuList" :key="i">
										<template v-for="(col, j) in row">
											<td v-if="rowspan(i, j)" :rowspan="rowspan(i, j)">{{specData[col].value}}</td>
										</template>
										<td>
											<c-input v-model="skuData[row.join(',')].cost_price" type="number" decimal="2" :disabled="view"></c-input>
										</td>
										<td>
											<c-input v-model="skuData[row.join(',')].stock" type="number" :disabled="!skuData[row.join(',')].new || view"></c-input>
										</td>
										<td>
											<c-input v-model="skuData[row.join(',')].oldPrice" type="number" decimal="2"></c-input>
										</td>
										<td v-if="skuPrivateImage">
											<div class="sku-image flex-center-cross">
												<div v-for="(img, k) in skuData[row.join(',')].image" :key="k" class="image" @click.stop @mouseenter="editImage = img">
													<div class="main flex-center" @click="delSkuImage(row.join(','), k)">
														<img :src="img.img">
														<p class="ellipsis">{{img.name}}</p>
														<a class="delete flex-center"><i class="tf tf-cross"></i></a>
													</div>
													<div v-show="editImage == img" class="preview-box">
														<div class="preview">
															<c-file class="image" :src="img.img" media></c-file>
															<c-input v-model="img.name" class="input" maxlength="6" placeholder="图片描述(最多6个字)" :disabled="view"></c-input>
														</div>
													</div>
												</div>
												<div v-if="skuData[row.join(',')].image.length < 5 && !view" class="image" @click="setSkuImage(row.join(','))" >
													<div class="main flex-center">
														<i class="tf tf-plus"></i>
													</div>
												</div>
											</div>
										</td>
										<td>
											<c-input v-model="skuData[row.join(',')].weight" type="number" decimal="2" :disabled="view"></c-input>
										</td>
										<td>
											<c-input v-model="skuData[row.join(',')].code" :disabled="currentSkuCode == 1 || view" ></c-input>
										</td>
									</tr>
								</template>
							</tbody>
						</table>
						<div class="total">总库存：{{totalStock}}件</div>
					</div>
				</c-form-item>
                
				<template v-else>
					<c-form-item label="编码" required :disabled="currentSkuCode == 1">
						<c-input v-model="skuData.product_sku_code" :disabled="view || currentSkuCode == 1"></c-input>
					</c-form-item>
					<c-form-item label="销售价" required>
						<c-input v-model="skuData.product_price" type="number" decimal="2" :disabled="view"></c-input>
					</c-form-item>
					<c-form-item label="库存" required>
						<c-input v-model="skuData.product_sku_stock" type="number" :disabled="view"></c-input>
					</c-form-item>
					<c-form-item label="重量">
						<c-input v-model="skuData.product_weight" type="number" decimal="2" :disabled="view"></c-input>
					</c-form-item>
				</template>
				
				<c-form-item v-show ="systemConfig.is_outstock == 'ON'" label="缺货订购" width="1000"
                             word="商品支持缺货订购，则表示在无库存的情况下平台用户也可以正常下单购买该商品">
                    <c-radio-group name="is_outstock" v-model="productIsOutstock" :options="isOutstockOptions" ></c-radio-group>
                </c-form-item>
				<c-form-item label="是否定制" width="1000" v-show="systemConfig.product_custom == 'ON'" >
					<c-radio-group v-model="productCustom" name="is_custom" :disabled="view">
						<c-radio value="0">否</c-radio>
						<c-radio value="1">支持定制</c-radio>
					</c-radio-group>
					
					<div v-show="productCustom == 1" style="padding: 10px 0;">
						<c-form-item v-show="customTempList" label="定制历史记录">
							<c-select v-model="currentCustomTemp" :options="customTempList" :disabled="view"></c-select>
						</c-form-item>
						
						<c-form-item label="选择定制项" width="600">
							<c-checkbox-group v-model="currentCustomItem" :disabled="view">
								<c-checkbox v-for="(item, i) in customItem" :key="i" :value="item.item_id">{{item.item_name}}</c-checkbox>
							</c-checkbox-group>
						</c-form-item>
							
						<div v-show="currentCustomItem.length" class="box detail custom-detail" style="margin-bottom: 16px;">
							<ul class="flex custom-item">
								<li v-for="(item, i) in currentCustomItemData" :key="i" :class="{'z-crt': item.item_id == currentCustomItemTab}" @click="currentCustomItemTab = item.item_id">{{item.item_name}}</li>
							</ul>
							<div v-for="(custom, i) in currentCustomItemData" :key="i" v-show="currentCustomItemTab == custom.item_id">
								<template v-if="custom.item_type == 1">
									<table class="detail-table">
										<thead>
											<tr>
												<th style="width: 300px;">定制位置</th>
												<th style="width: 300px;">工艺</th>
												<th style="width: 150px;"><b>*</b>最小起订量<a v-if="!view" @click.stop="batchSetCustom('min_custom_count', '起订量', custom, $event)"><i class="tf tf-edit"></i></a></th>
												<th style="width: 150px;"><b>*</b>加价<a v-if="!view" @click.stop="batchSetCustom('product_price_cost', '加价', custom, $event)"><i class="tf tf-edit"></i></a></th>
												<th style="width: 80px;">操作</th>
											</tr>
										</thead>
										<tbody>
											<template v-for="(item, j) in custom.list">
												<tr :key="j">
													<td v-if="customPositionCell(custom.list, j)" :rowspan="customPositionCell(custom.list, j)">
														<div class="position flex-column flex-center">
															<c-file class="position-image" :src="item.position_image_url" media></c-file>
															<p>{{item.position_name}}</p>
														</div>
													</td>
													<td v-if="!item.tech_id" colspan="4">未选择工艺</td>
													<template v-else>
														<td>{{item.tech_name}}</td>
														<td>
															<c-input v-model="item.min_custom_count" type="number" :disabled="view"></c-input>
														</td>
														<td>
															<c-input v-model="item.product_price_cost" type="number" decimal="2" :disabled="view"></c-input>
														</td>
														<td><a class="remove" @click="deleteCustomItemOption(custom, j, item.position_id)" v-if="!view">删除</a></td>
													</template>
												</tr>
												<tr v-if="customPositionAdd(custom.list, j) " :key="`${j}add`">
													<td colspan="4">
														<c-link @click="addCustomItemOption(custom, item, j)" v-if="!view">添加工艺</c-link>
														<c-link class="remove" style="margin-left: 15px;" @click="deleteCustomItemOption(custom, 'all', item.position_id)"  v-if="!view">删除位置</c-link>
													</td>
												</tr>
											</template>
										</tbody>
									</table>
									<c-button color="main" @click="addCustomItemOption(custom)" v-if="!view">添加定制位置</c-button>
									
									<c-dialog ref="customPositionDialog" title="添加定制位置" width="800" height="440" @resolve="addCustomItemOptionHandle">
										<div class="custom-option">
											<div><c-button hollow @click="customOptionAllCheckHandle">全选</c-button></div>
											<c-checkbox-group v-if="custom.position" ref="customPosition">
												<div class="position-list flex-wrap">
													<div v-for="(item, i) in custom.position" :key="i" class="position">
														<c-file class="position-image" :src="item.img_url" media></c-file>
														<div class="position-check">
															<c-checkbox :value="item.id" :disabled="item.checked">{{item.name}}</c-checkbox>
														</div>
													</div>
												</div>
											</c-checkbox-group>
										</div>
									</c-dialog>
									<c-dialog ref="customTechnicsDialog" title="添加工艺" width="600" height="240" @resolve="addCustomItemOptionHandle">
										<div class="custom-option">
											<div><c-button hollow @click="customOptionAllCheckHandle">全选</c-button></div>
											<c-checkbox-group v-if="custom.technics" ref="customTechnics">
												<c-checkbox v-for="(item, i) in custom.technics" :key="i" :value="item.id" :disabled="item.checked">{{item.name}}</c-checkbox>
											</c-checkbox-group>
										</div>
									</c-dialog>
								</template>
								
								<template v-else>
									<table class="detail-table">
										<thead>
											<tr>
												<th style="width: 200px;">{{custom.item_name}}</th>
												<th v-if="custom.item_type == 3" style="width: 200px;">颜色色值</th>
												<th style="width: 150px;"><b>*</b>最小起订量<a v-if="!view" @click.stop="batchSetCustom('min_custom_count', '起订量', custom, $event)"><i class="tf tf-edit"></i></a></th>
												<th style="width: 150px;"><b>*</b>加价<a v-if="!view" @click.stop="batchSetCustom('product_price_cost', '加价', custom, $event)"><i class="tf tf-edit"></i></a></th>
												<th style="width: 80px;">操作</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, j) in custom.list" :key="j">
												<td>{{item.param_value}}</td>
												<td v-if="custom.item_type == 3">
													<div class="flex-center-cross color">
														<div><div :style="{'background': item.param_code}"></div></div>
														<span>{{item.param_code}}</span>
													</div>
												</td>
												<td>
													<c-input v-model="item.min_custom_count" type="number"></c-input>
												</td>
												<td>
													<c-input v-model="item.product_price_cost" type="number" decimal="2"></c-input>
												</td>
												<td><a class="remove" @click="deleteCustomItemOption(custom, j)" v-if="!view">删除</a></td>
											</tr>
										</tbody>
									</table>
									<c-button color="main" @click="addCustomItemOption(custom)" v-if="!view">添加{{custom.item_name}}项</c-button>
									
									<c-dialog :ref="`customOptionDialog${custom.item_id}`" :title="`添加${custom.item_name}项`" width="600" height="240" @resolve="addCustomItemOptionHandle">
										<div class="custom-option">
											<div><c-button hollow @click="customOptionAllCheckHandle">全选</c-button></div>
											<c-checkbox-group v-if="custom.option" :ref="`customOption${custom.item_id}`">
												<c-checkbox v-for="(item, i) in custom.option" :key="i" :value="item.id" :disabled="item.checked">{{item.name}}</c-checkbox>
											</c-checkbox-group>
										</div>
									</c-dialog>
								</template>
							</div>
						</div>
						
						<c-form-item label="定制说明">
							<c-input type="textarea" name="custom_remark" :disabled="view"></c-input>
						</c-form-item>
					</div>
				</c-form-item>
                <c-form-item label="限购方式" width="1000" required word="待支付未关闭或已支付订单商品计入购买量，订单商品完成退款或退货后，则从限购数量中减去">
                    <c-radio-group name="activity_notice" v-model="purchase_limit_type" :options="purchaseLimitTypeOptions" ></c-radio-group>
                </c-form-item>
                <c-form-item label="限购数量" v-show="purchase_limit_type != 0" required>
                    <c-input type="number" decimal="0" :limit="[1,999999]" v-model="purchase_max_count" name="purchase_max_count" unit="件" style="width:120px"></c-input>
                </c-form-item>
                <c-form-item label="上架设置" required>
					<c-radio-group v-model="salesDate" name="product_first_sell_type" :disabled="view">
                        <c-radio value="2">立即上架</c-radio>
                        <c-radio value="1">手动上架</c-radio>
						<c-radio value="3">定时上架</c-radio>
					</c-radio-group>
				</c-form-item>
				<c-form-item v-show="salesDate == 3" label="上架时间" required>
					<c-datetime name="auto_sell_date"></c-datetime>
				</c-form-item>
				<c-form-item v-if="isVirtual == 0" label="运费模板" required>
					<c-select name="freight_template_id" :options="freightTmplOptions" :disabled="view"></c-select>
					<template #tip v-if="!view">
						  <c-link @click="getFreightTmpl()">刷新</c-link>
                          <c-link v-if="auth('b_freight_template')" style="margin-left: 10px;" @click="addFreightTmpl()">新建模板</c-link>
					</template>
				</c-form-item>
			</c-form>
			
			<template slot="button" v-if="!view">
				<c-button color="main" size="form" @click="submit(productState == 0 ? 2 : 3)">提交发布</c-button>
				<c-button v-if="productState == 0" size="form" hollow @click="submit(1)">暂存草稿</c-button>
			</template>
			
			<div v-show="batchSetData" ref="batchSet" class="batch-set" :style="{'top': batchSetData.top, 'left': batchSetData.left}" @click.stop>
				<p>批量填写{{batchSetData.name}}</p>
				<div class="flex">
					<c-input v-if="batchSetData" v-model="batchSetData.value" ref="batchSetInput" type="number" :decimal="batchSetData.decimal" @enter="batchSetHandle"></c-input>
					<c-button color="sys" @click="batchSetHandle">确定</c-button>
				</div>
			</div>
			
			<c-dialog ref="detailText" title="插入文本" width="500" @resolve="insertDetailText">
				<div class="detail-text-edit">
					<textarea v-model="detailEditText"></textarea>
				</div>
			</c-dialog>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import {debounce} from '@deanwu/vue-component-library'
	
	function getStyleComputedProperty(element, property) {
		var css = window.getComputedStyle(element, null);
		return css[property];
	}
	
	function getScrollParent(element, fun) {
		var parent = element.parentNode;
	
		if (!parent) {
			return;
		}
		if (parent === window.document) {
			if (window.document.body.scrollTop || window.document.body.scrollLeft) {
				return fun(window.document.body);
			} else {
				return fun(window);
			}
		}
		
		if (
			['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 ||
			['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 ||
			['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1
		) {
			fun(parent);
		}
		return getScrollParent(element.parentNode, fun);
	}
	
	export default {
		props: {
			classify: String,
			classifyName: String,
            view: Boolean,
			id: String
		},
		
		data() {
			return {
				productState : 0,
				productClassify: '',
				productClassifyName: [],
				
				paramConfig: [],
				paramValue: {},
				attrConfig: [],
				attrValue: {},
				
				detailList: [],
				detailEditText: '',
				
				imageScale: 2,
				currentSkuCode: 1,
				salesDate: 2,
				
				freightTmplOptions: [],
				
				singleSkuMode: false,
				specIndex: 0,
				specList: [],
				specData: {},
				skuData: {},
				skuPrivateImage: false,
				
				productCustom: 0,
				customTempList: '',
				currentCustomTemp: '',
				customItem: [],
				currentCustomItem: [],
				currentCustomItemTab: '',
				
				editImage: '',
				batchSetData: '',
                purchase_limit_type:0,
                purchase_max_count:0,
                purchaseLimitTypeOptions: [
                    {name: '不限购',value: 0},
                    {name: '终身限购',value: 1},
                    {name: '按单限购',value: 2}
                ],
                isOutstockOptions: [
                    {name: '不支持',value: 1},
                    {name: '支持缺货订购',value: 2}
                ],
				isVirtual: 0,
                isVirtualOption: {
                    0:'实物商品',
                    1:'虚拟商品'
                },
                productIsOutstock:1,  //是否支持缺货订购(1-不支持 2-支持)
                effectiveMonths:12,
                expireCardRefund: 1,//卡券到期未消费处理方式 1=不退款 ；2=退款
                expireCardRefundOption:[
                    {name: '不退款',value: 1},
                    {name: '退款',value: 2},
                ]
            }
		},
		
		computed: {
			...mapState(['systemConfig']),
			
			compClassifyName() {
                var virtualName = `【${this.isVirtualOption[this.isVirtual]}】`;
                return virtualName+`（类目：${this.id ? this.productClassifyName.join(' > ') : this.classifyName.split(',').join(' > ')}）`;
			},
			
			skuList() {
				var that = this, skuList = [];
				!function poll(index, tree, isNew) {
					let list = that.specList[index];
					if (!list) {
						if (tree) {
							if (!that.skuData[tree]) {
								// var specImg = tree.split(',').find(item => that.specData[item].image);
								that.$set(that.skuData, tree, {
									id: `sku${that.specIndex++}`,
									price: '',
									cost_price: '',
									stock: '',
									oldPrice: '',
									image: [],
									weight: '',
									code: '',
									new: isNew
								});
							}
							skuList.push(tree.split(','));
						}
						return;
					}
					list.itemList.forEach(item => {
						let t = tree ? tree.split(',') : [];
						t.push(item.id);
						poll(index+1, t.join(','), isNew ? isNew : item.new);
					});
				}(0);
				
				return skuList;
			},
			
			rowspan() {
				return (row, col) => {
					var count = 1;
					for (let i = col+1; i < this.specList.length; i++) {
						count *= this.specList[i].itemList.length;
					}
					
					return row % count ? 0 : count;
				}
			},
			
			totalStock() {
				var total = 0;
				this.skuList.forEach(row => {
					total += parseInt(this.skuData[row.join(',')].stock) || 0;
				});
				return total;
			},
			
			currentCustomItemData() {
				return this.customItem.filter(item => this.currentCustomItem.includes(item.item_id.toString()));
			},
			
			customPositionCell() {
				return (list, i) => {
					if (i == 0 || list[i - 1].position_name != list[i].position_name) {
						return list.filter(item => item.position_name == list[i].position_name).length + 1;
					}
					return 0;
				}
			},
			
			customPositionAdd() {
				return (list, i) => {
					return (i == list.length - 1) || list[i + 1].position_name != list[i].position_name;
				}
			}
		},
		
		watch: {
			id() {
				this.getProductDetail();
			},
			
			classify() {
				this.getParamList();
				this.getAttrList();
			},
			
			productClassify() {
				this.getParamList();
				this.getAttrList();
				this.getCustomTemp();
			},
			
			currentCustomTemp(val) {
				if (val) {
					let data = this.customTempList.find(item => item.value == val).data.custom_item_list;
					this.customItem = data;
					this.currentCustomItem = Array.from(data.filter(item => item.list.length), item => {
						item.list.forEach(item => {
							item.min_custom_count = item.min_custom_count.toString();
							item.product_price_cost = item.product_price_cost.toString();
						});
						return item.item_id.toString();
					});
				}
			},
			
			currentCustomItemData(val) {
				if (val.length) {
					if (!val.find(item => item.item_id == this.currentCustomItemTab)) {
						this.currentCustomItemTab = val[0].item_id;
					}
				}
			},
			
			batchSetData(val) {
				val && this.$nextTick(() => {
					this.$refs.batchSetInput.focus();
				});
			}
		},
		
		mounted() {
			if (this.classify) {
				this.getParamList();
				this.getAttrList();
				this.getSpecList();
				this.getCustomTemp();
			} else {
				this.getProductDetail();
			}
			this.getCustomItem();
			
			this.getFreightTmpl();
			this.$bus.$on('productEdit.updateFreightTmpl', () => {
				this.getFreightTmpl();
			});
			
			getScrollParent(this.$refs.batchSet, dom => {
				dom.addEventListener('scroll', () => {
					if (this.batchSetData && this.batchSetData.target) {
						let rect = this.batchSetData.target.getBoundingClientRect();
						this.batchSetData.top = rect.top + 20 + 'px';
						this.batchSetData.left = rect.left + 'px';
					}
				});
			});
		},
		
		methods: {
			getParamList() {
				this.request({
					url: '/product_param/common_list',
					data: {
						type:1,
						product_type_id: this.classify || this.productClassify
					},
					success: data => {
						if (data) {
							this.paramConfig = Array.from(data, item => {
								item.parameter_type = item.parameter_type == 'text' ? 'input' : item.parameter_type;
								item.parameter_values = Array.from(item.parameter_values.split(','), item => {
									return {
										name: item,
										value: item
									}
								});
								return item;
							});
							
							this.$nextTick(() => {
								this.$refs.paramForm.set(this.paramValue);
							});
						}
					}
				});
			},
			getAttrList() {
				this.request({
					url: '/product_param/common_list',
					data: {
						type:2,
						product_type_id: this.classify || this.productClassify
					},
					success: data => {
						if (data) {
							this.attrConfig = Array.from(data, item => {
								item.parameter_type = item.parameter_type == 'text' ? 'input' : item.parameter_type;
								item.parameter_values = Array.from(item.parameter_values.split(','), item => {
									return {
										name: item,
										value: item
									}
								});
								return item;
							});

							this.$nextTick(() => {
								this.$refs.attrForm.set(this.attrValue);
							});
						}
					}
				});
			},
			getSpecList() {
				this.request({
					url: '/product_type/common_specs',
					data: {
						product_type_id: this.classify || this.productClassify
					},
					success: data => {
                        this.isVirtual = data.is_virtual;
						this.singleSkuMode = data.sku_modue == 1;
						this.skuPrivateImage = data.is_support_sku_img == 1;
						this.initSpec(data.spec_list, true);
					}
				});
			},
			getProductDetail() {
				this.request({
					url: '/product/detail',
					data: {
						product_id: this.id
					},
					loading: true,
					success: data => {
						this.singleSkuMode = data.base_info.sku_modue == 1;
						this.productState = data.base_info.state;
						this.productClassify = data.base_info.product_type_id;
						this.productClassifyName = data.base_info.product_type_full_name.split(' > ');
                        this.isVirtual = data.base_info.is_virtual;
                        this.purchase_limit_type = data.base_info.purchase_limit_type;
                        this.productIsOutstock = data.base_info.is_outstock;
                        this.purchase_max_count = data.base_info.purchase_limit_type==0?0:data.base_info.purchase_max_count;
                        this.effectiveMonths = data.base_info.effective_months?data.base_info.effective_months:12;
                        this.expireCardRefund = data.base_info.expire_card_refund?data.base_info.expire_card_refund:1;

                        this.getFreightTmpl(data.base_info.freight_template_id);
                        data.product_paramter_list.forEach(item => {
							this.paramValue[item.parameter_id] = item.parameter_value;
						});
						data.product_attr_list.forEach(item => {
							this.attrValue[item.parameter_id] = item.parameter_value;
						});
						
						let video = data.product_img_list.find(item => item.type == 2);
						this.$refs.form.set(Object.assign(data.base_info, {
							product_square_img: data.base_info.product_img_type == 1 ? data.base_info.product_img_url : '',
							product_img_list: Array.from(data.product_img_list.filter(item => item.type == 1), item => item.image_url),
							product_video_url: video ? video.image_url : ''
						}));
						
						if (data.base_info.product_content) {
							try {
								this.detailList = JSON.parse(data.base_info.product_content);
							} catch(e) {}
						}
						
						this.skuPrivateImage = data.base_info.is_support_sku_img == 1;
						this.initSpec(data.product_spec_list);
						
						if (this.singleSkuMode) {
							this.skuData = data.product_sku_list[0];
						} else {
							var that = this;
							!function poll(list, tree) {
								list.forEach(item => {
									let specKey = tree.concat([item.group_id]);
									if (item.children) {
										poll(item.children, specKey);
									} else {
										try {
											var image = JSON.parse(item.product_img_url) || [];
										} catch(e) {
											var image = Array.from(item.product_img_url ? item.product_img_url.split(',') : [], item => {
												return {
													img: item,
													name: ''
												}
											})
										}
										that.$set(that.skuData, specKey.join(','), {
											id: item.product_sku,
											price: item.product_price.toString(),
											cost_price: item.product_price_cost.toString(),
											stock: item.product_sku_stock.toString(),
											oldPrice: item.product_price_tag || '',
											image,
											weight: item.product_weight.toString() || '',
											code: item.product_sku_code.toString() || ''
										});
									}
								});
							}(data.product_sku_list, []);
						}
					}
				});
			},
			getFreightTmpl(id) {
				this.request({
					url: '/freight_template/options',
					success: data => {
						this.freightTmplOptions = Array.from(data, item => {
							return {
								name: item.option,
								value: item.id
							}
						});
                        if (id) {
                            this.$nextTick(() => {
                                this.$refs.form.set({
                                    freight_template_id: id
                                });
                            });
                        }
					}
				});
			},
            //添加模板
			addFreightTmpl() {
                this.navigateTo('/freight_template_add','new');
			},
			insertDetailItem(type, item) {
				if (this.detailList.length >= 50) {
					this.$message({
						message: '最多只能插入50条内容'
					});
					return;
				}
				
				if (type == 'image') {
					this.$selectFile({
						count: 50 - this.detailList.length,
						success: data => {
							data.forEach(item => {
								this.detailList.push({
									type: 'image',
									content: item.path
								});
							});
						}
					});
				} else {
					this._editDetailText = item;
					this.detailEditText = item ? item.content : '';
					this.$refs.detailText.open();
				}
			},
			
			delDetailItem(i) {
				this.detailList.splice(i, 1);
			},
			
			insertDetailText(stop) {
				if (!this.detailEditText) {
					stop();
					this.$message({
						message: '请填写内容'
					})
					return;
				}
				
				if (this._editDetailText) {
					this._editDetailText.content = this.detailEditText;
				} else {
					this.detailList.push({
						type: 'text',
						content: this.detailEditText
					});
				}
			},
			
			initSpec(data, apply) {
				this.specList = Array.from(data, spec => {
					return {
						name: spec.group_name,
						image: spec.group_img_flag == 2,
						itemList: Array.from(spec.children, item => {
							let id = apply ? `spec${this.specIndex++}` : item.group_id;
							try {
								var image = JSON.parse(item.group_img) || [];
							} catch(e) {
								var image = Array.from(item.group_img ? item.group_img.split(',') : [], item => {
									return {
										img: item,
										name: ''
									}
								});
							}
							
							this.$set(this.specData, id, {
								value: item.group_value,
								image
							});
							
							return {
								new: apply,
								id
							}
						})
					}
				});
			},
			
			addSpec() {
				if (this.specList.length == 3) {
					this.$message({
						message: '最多只能添加三个规格项'
					});
					return;
				}
				var item = {
					new: true,
					name: '',
					image: false,
					itemList: []
				};
				this.specList.push(item);
				this.addSpecItem(item);
			},
			
			removeSpec(index) {
				this.specList.splice(index, 1);
			},
			
			specValueVerify(id, list) {
				if (list.find(item => {
					return item.id != id && this.specData[item.id].value == this.specData[id].value;
				})) {
					this.$message({
						message: '规格值不能重复<br>请重新输入'
					});
					this.specData[id].value = '';
				}
			},
			
			addSpecItem(spec) {
				var id = `spec${this.specIndex++}`;
				
				this.$set(this.specData, id, {
					value: '',
					image: []
				});
				
				spec.itemList.push({
					new: true,
					id
				});
			},
			
			setSpecItemImage(spec) {
				this.$selectFile({
					count: 5 - this.specData[spec.id].image.length,
					success: data => {
						this.specData[spec.id].image = this.specData[spec.id].image.concat(Array.from(data, item => {
							return {
								img: item.path,
								name: ''
							}
						}));
					}
				});
			},
			
			delSpecItemImage(spec, i) {
				this.specData[spec.id].image.splice(i, 1);
			},
			
			removeItem(spec, index) {
				spec.itemList.splice(index, 1);
			},
			
			batchSetSku(type, name, e) {
				let rect = e.target.getBoundingClientRect();
				this.batchSetData = {
					name,
					value: '',
					target: e.target,
					top: rect.top + 20 + 'px',
					left: rect.left + 'px',
					decimal: type == 'stock' ? 0 : 2,
					handle: data => {
						data = parseFloat(data);
						if (!data && data !== 0) return;
						this.skuList.forEach(specKey => {
							if (type != 'stock' || this.skuData[specKey].new) {
								this.skuData[specKey][type] = data.toString();
							}
						});
					}
				};
			},
			
			batchSetCustom(type, name, custom, e) {
				let rect = e.target.getBoundingClientRect();
				this.batchSetData = {
					name,
					value: '',
					target: e.target,
					top: rect.top + 20 + 'px',
					left: rect.left + 'px',
					decimal: type == 'product_price_cost' ? 2 : 0,
					handle: data => {
						data = parseFloat(data);
						if (!data && data !== 0) return;
						custom.list.forEach(item => {
							item[type] = data.toString();
						});
					}
				};
			},
			
			batchSetHandle() {
				this.batchSetData.handle(this.batchSetData.value);
				this.batchSetData = '';
			},
			
			setSkuImage(specKey) {
				this.$selectFile({
					count: 5 - this.skuData[specKey].image.length,
					success: data => {
						this.skuData[specKey].image = this.skuData[specKey].image.concat(Array.from(data, item => {
							return {
								img: item.path,
								name: ''
							}
						}));
					}
				});
			},
			
			delSkuImage(specKey, i) {
				this.skuData[specKey].image.splice(i, 1);
			},
			
			previewSkuImage(src) {
				src && this.$preview({
					src
				});
			},
			
			getCustomItem() {
				this.request({
					url: '/product/custom/info',
					data: this.classify ? {
						product_type_id: this.classify
					} : {
						product_id: this.id
					},
					success: data => {
						this.customItem = data;
						this.currentCustomItem = Array.from(data.filter(item => item.list.length), item => {
							item.list.forEach(item => {
								item.min_custom_count = item.min_custom_count.toString();
								item.product_price_cost = item.product_price_cost.toString();
							});
							return item.item_id.toString();
						});
					}
				});
			},
			
			getCustomTemp() {
				this.request({
					url: '/product/custom/template',
					data: {
						product_type_id: this.classify || this.productClassify
					},
					success: data => {
						if (data && data.length) {
							this.customTempList = Array.from(data, item => {
								return {
									name: item.product_name,
									value: item.product_id,
									data: item
								}
							});
						}
					}
				});
			},
			
			addCustomItemOption(custom, technics, index) {
				this._addCustomItem = {custom, technics, index};
				if (custom.item_type == 1) {
					let type = technics ? 'technics' : 'position';
					if (!custom[type]) {
						this.request({
							url: '/custom/item/param/list',
							data: {
								product_type_id: this.classify || this.productClassify,
								item_id: custom.item_id,
								type: technics ? 2 : 1
							},
							success: data => {
								this.$set(custom, type, data || []);
								this.$nextTick(() => {
									this.addCustomItemOption(custom, technics, index);
								});
							}
						})
					} else {
						if (technics) {
							custom.technics.forEach(item => {
								this.$set(item, 'checked', !!custom.list.find(temp => temp.position_id == technics.position_id && temp.tech_id == item.id));
							});
							this.$refs.customTechnics[0].set(Array.from(custom.list.filter(item => item.position_id == technics.position_id), item => item.tech_id));
							this.$refs.customTechnicsDialog[0].open();
						} else {
							custom.position.forEach(item => {
								this.$set(item, 'checked', !!custom.list.find(temp => temp.position_id == item.id));
							});
							this.$refs.customPosition[0].set(Array.from(custom.list, item => item.position_id));
							this.$refs.customPositionDialog[0].open();
						}
					}
				} else {
					if (!custom.option) {
						this.request({
							url: '/custom/item/param/list',
							data: {
								product_type_id: this.classify || this.productClassify,
								item_id: custom.item_id,
								type: 3
							},
							success: data => {
								this.$set(custom, 'option', data || []);
								this.$nextTick(() => {
									this.addCustomItemOption(custom);
								});
							}
						})
					} else {
						custom.option.forEach(item => {
							this.$set(item, 'checked', !!custom.list.find(temp => temp.item_param_id == item.id));
						});
						this.$refs[`customOption${custom.item_id}`][0].set(Array.from(custom.list, item => item.item_param_id));
						this.$refs[`customOptionDialog${custom.item_id}`][0].open();
					}
				}
			},
			
			customOptionAllCheckHandle() {
				let {custom, technics, index} = this._addCustomItem;
				
				if (custom.item_type == 1) {
					if (technics) {
						this.$refs.customTechnics[0].set(custom.technics.map(item => item.id.toString()));
					} else {
						this.$refs.customPosition[0].set(custom.position.map(item => item.id.toString()));
					}
				} else {
					this.$refs[`customOption${custom.item_id}`][0].set(custom.option.map(item => item.id.toString()));
				}
			},
			
			addCustomItemOptionHandle: debounce(function() {
				let {custom, technics, index} = this._addCustomItem;
				
				if (custom.item_type == 1) {
					if (technics) {
						let data = this.$refs.customTechnics[0].get();
						let add = [];
						custom.technics.forEach(item => {
							if (!item.checked && data.includes(item.id.toString())) {
								add.push({
									position_id: technics.position_id,
									position_image_url: technics.position_image_url,
									position_name: technics.position_name,
									tech_id: item.id,
									tech_name: item.name,
									min_custom_count: '1',
									product_price_cost: ''
								})
							}
						});
						add.length && custom.list.splice.apply(custom.list, [technics.tech_id ? index + 1 : index, technics.tech_id ? 0 : 1].concat(add));
					} else {
						let data = this.$refs.customPosition[0].get();
						custom.position.forEach(item => {
							if (!item.checked && data.includes(item.id.toString())) {
								custom.list.push({
									position_id: item.id,
									position_image_url: item.img_url,
									position_name: item.name,
									tech_id: '',
									tech_name: '',
									min_custom_count: '1',
									product_price_cost: ''
								});
							}
						});
					}
				} else {
					let data = this.$refs[`customOption${custom.item_id}`][0].get();
					console.log(data)
					custom.option.forEach(item => {
						if (!item.checked && data.includes(item.id.toString())) {
							custom.list.push({
								item_param_id: item.id,
								param_value: item.name,
								min_custom_count: '1',
								product_price_cost: '',
								param_code: item.code
							});
						}
					});
				}
			}, 200, true),
			
			deleteCustomItemOption(custom, index, position) {
				if (position !== undefined) {
					if (index == 'all') {
						custom.list.splice(custom.list.findIndex(item => item.position_id == position), custom.list.filter(item => item.position_id == position).length);
					} else {
						if (custom.list.filter(item => item.position_id == position).length == 1) {
							let temp = custom.list.find(item => item.position_id == position);
							custom.list.splice(index, 1, {
								position_id: temp.position_id,
								position_image_url: temp.position_image_url,
								position_name: temp.position_name,
								tech_id: '',
								tech_name: '',
								min_custom_count: '1',
								product_price_cost: ''
							});
						} else {
							custom.list.splice(index, 1);
						}
					}
				} else {
					custom.list.splice(index, 1);
				}
			},
			
			submit(type) {
				this.$refs.form.submit({
					url: this.id ? '/product/edit' : '/product/add',
					
					rule: {
						product_name: '请填写商品标题',
						product_itemnumber: [{
							type: 'empty',
							skip: () => {
								return this.systemConfig.product_number_required == 'OFF' && this.systemConfig.product_sku_code_autocreate_type != 'productnumberseq';
							},
							message: '请填写商品货号'
						}],
						product_attr_list: [{
							type: 'function',
							fun: value => {
								return !this.attrConfig.find(item => {
									return item.required_flag == 2 && !value[item.id];
								});
							},
							message: '请填写带星号的商品属性'
						}],
						product_paramter_list: [{
							type: 'function',
							fun: value => {
								return !this.paramConfig.find(item => {
									return item.required_flag == 2 && !value[item.id];
								});
							},
							message: '请填写带星号的商品参数'
						}],
						product_img_list: [{
							type: 'function',
							fun: value => {
								return value.length;
							},
							message: '请至少选择一张商品主图'
						}],
						product_square_img: [{
							type: 'empty',
							skip: () => {
								return this.imageScale == 2;
							},
							message: '请选择商品1:1主图'
						}],
						spec: [{
							type: 'function',
							fun: () => {
								var state = true;
								for (let i in this.specList) {
									if (!this.specList[i].itemList.length) {
										state = false;
										break;
									}
								}
								return state;
							},
							message: '请添加SKU配置规格值'
						}],
						spec_value: [{
							type: 'function',
							fun: () => {
								var state = true;
								for (let i in this.specList) {
									for (let j in this.specList[i].itemList) {
										if (!this.specData[this.specList[i].itemList[j].id].value) {
											state = false;
											break;
										}
									}
								}
								return state;
							},
							message: '请完善规格值'
						}],
						sku_config: [{
							type: 'function',
							fun: () => {
								if (this.singleSkuMode) {
									return this.skuData.product_price && this.skuData.product_sku_stock;
								} else {
									var state = true;
									for (let i in this.skuList) {
										let sku = this.skuData[this.skuList[i].join(',')];
										if (!sku.cost_price ||isNaN(sku.cost_price)|| !sku.stock ||isNaN(sku.stock)) {
											state = false;
											break;
										}
									}
									return state;
								}
							},
							message: '请完善SKU价格及库存'
						}],
						sku_code: [{
							type: 'function',
							fun: () => {
								if (this.singleSkuMode) {
									return this.skuData.product_sku_code;
								} else {
									var state = true;
									for (let i in this.skuList) {
										let sku = this.skuData[this.skuList[i].join(',')];
										if (!sku.code) {
											state = false;
											break;
										}
									}
									return state;
								}
							},
							skip: () => {
								return this.currentSkuCode == 1;
							},
							word: '请完善SKU编码'
						}],
                        sku_weight: [{
                            type: 'function',
                            fun: () => {
                                var state = true;
                                for (let i in this.skuList) {
                                    let sku = this.skuData[this.skuList[i].join(',')];
                                    if (sku.weight && isNaN(sku.weight)) {
                                        state = false;
                                        break;
                                    }
                                }
                                return state;
                            },
                            skip: () => {
                                return this.skuList.length == 0;
                            },
                            word: '商品重量信息只能输入数字'
                        }],
						custom_item: () => {
							if (this.productCustom == 1) {
								if (!this.currentCustomItem.length) {
									this.$message({
										message: '请选择定制项'
									});
									return false;
								}
								
								let custom = this.currentCustomItemData.find(custom => {
									if (!custom.list.length) {
										return true;
									}
									
									return custom.list.find(item => {
										return (custom.item_type == 1 && !item.tech_id) || !item.product_price_cost.toString() || !item.min_custom_count.toString();
									})
								});
								
								if (custom) {
									this.$message({
										message: `请完善定制项【${custom.item_name}】`
									});
									return false;
								}
							}
							return true;
						},
						auto_sell_date: [{
							type: 'empty',
							skip: () => {
								return this.salesDate != 3;
							},
							message: '请选择上架时间'
						}],
                        freight_template_id: [{
                            type: 'empty',
                            skip: () => {
                                return this.isVirtual != 0;
                            },
                            word: '请选择运费模板'
                        }],
                        purchase_max_count: [{
                            type: 'empty',
                            skip: () => {
                                return this.purchase_limit_type == 0;
                            },
                            message: '请设置限购数量'
                        }],
                        effective_months: [{
                            type: 'empty',
                            skip: () => {
                                return this.isVirtual == 0;
                            },
                            word: '请填写卡券有效期'
                        }]
					},
					
					dataFormatter: data => {
						let specList = [];
						this.specList.forEach((spec, i) => {
							spec.itemList.forEach((item, j) => {
								specList.push({
									group_id: item.id,
									group_name: spec.name,
									group_value: this.specData[item.id].value,
									group_img_flag: spec.image ? 2 : 1,
									group_img: this.specData[item.id].image,
									group_level: i+1,
									sort_id: j+1
								});
							});
						});
						
						let skuList = [];
						if (this.singleSkuMode) {
							skuList = [Object.assign({
								product_sku: 'sku0'
							}, this.skuData)];
						} else {
							this.skuList.forEach(specKey => {
								let data = this.skuData[specKey.join(',')];
								skuList.push({
									product_sku: data.id + '',
									product_sku_spec_ids: specKey,
									product_sku_spec: Array.from(specKey, item => this.specData[item].value + '').join(' '),
									product_price: isNaN((data.price||data.cost_price))?'': (data.price||data.cost_price)+ '',
									product_price_tag: isNaN(data.oldPrice)?-1:data.oldPrice,
									product_price_cost: isNaN(data.cost_price)?'':(data.cost_price + ''),
									product_sku_stock: isNaN(data.stock)?'':(data.stock + ''),
									product_img_url: data.image,
									product_weight: isNaN(data.weight)?'':(data.weight + ''),
									product_sku_code: data.code + ''
								});
							});
						}
						
						data.product_id = this.id || 0;
						data.product_img_url = this.imageScale == 1 ? data.product_square_img : data.product_img_list[0];
						data.product_type_id = this.$route.query.classify || this.productClassify;
						data.product_content = JSON.stringify(this.detailList);
						data.is_support_sku_img = this.skuPrivateImage ? 1 : 0;
                        data.is_custom = this.productCustom;
                        data.purchase_limit_type = this.purchase_limit_type||0;
                        data.purchase_max_count = this.purchase_max_count||0;
                        data.is_outstock = this.productIsOutstock||1;
                        data.effective_months = data.effective_months||12;

						let paramData = data.product_paramter_list;
						let attrData = data.product_attr_list;
							
						let formData = {
							operate_type: type,
							base_info: data,
							product_paramter_list: Array.from(this.paramConfig, item => {
								return {
									parameter_id: item.id,
									parameter_value: typeof paramData[item.id] == 'string' ? paramData[item.id] : paramData[item.id].join(',')
								}
							}),
							product_attr_list: Array.from(this.attrConfig, item => {
								return {
									parameter_id: item.id,
									parameter_value: typeof attrData[item.id] == 'string' ? attrData[item.id] : attrData[item.id].join(',')
								}
							}),
							product_img_list: Array.from(data.product_img_list, (item, index) => {
								return {
									image_url: item,
									type: 1,
									sort_id: index + 1
								}
							}).concat(data.product_video_url ? [{
								image_url: data.product_video_url,
								type: 2,
								sort_id: data.product_img_list.length + 1
							}] : []),
							product_spec_list: specList,
							product_sku_list: skuList,
							
							is_custom: data.is_custom,
							min_custom_count: 1,
							custom_list: Array.from(this.currentCustomItemData, custom => {
								return {
									item_id: custom.item_id,
									item_type: custom.item_type,
									list: Array.from(custom.list, item => {
										return {
											position_id: item.position_id,
											tech_id: item.tech_id,
											item_param_id: item.item_param_id,
											min_custom_count: item.min_custom_count,
											product_price_cost: item.product_price_cost
										}
									})
								}
							}),
							custom_remark: data.custom_remark
						}
						
						delete data.product_paramter_list;
						delete data.product_attr_list;
						delete data.product_square_img;
						delete data.product_video_url;
						delete data.product_img_list;
						
						return formData;
					},
					
					success: (data, param) => {
						this.$message({
							type: 'success',
							message: '保存成功'
						});
						this.navigateTo('/product_list');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.box {
		background: #F9F8FB;
	}
	
	.params {
		box-sizing: border-box;
		padding: 20px 20px 30px;
	}
	
	.detail {
		padding: 15px;
		
		&-preview {
			width: 370px;
			border: 1px solid #ddd;
			margin-right: 30px;
			background: #fff;
			
			dt {
				border-bottom: 1px solid #ddd;
				line-height: 40px;
				font-size: 13px;
				font-weight: bold;
				text-indent: 12px;
			}
			
			dd {
				height: 560px;
				overflow: auto;
				font-size: 0;
				
				img {
					width: 100%;
					max-height: initial;
				}
				
				div {
					font-size: 12px;
					line-height: 18px;
					padding: 6px 10px;
					white-space: pre-wrap;
				}
			}
		}
		
		&-edit {
			.tips {
				line-height: 40px;
				font-size: 12px;
				color: #666;
				
				b {
					font-weight: bold;
					color: #f00;
				}
			}
			
			&-item {
				position: relative;
				box-sizing: border-box;
				width: 100px;
				height: 100px;
				border: 1px solid #ddd;
				margin-right: 12px;
				margin-bottom: 12px;
				background: #fff;
				
				&.insert {
					border: none;
					background: none;
					
					.c-button {
						margin: 5px 0;
					}
				}
				
				.text {
					align-self: flex-start;
					box-sizing: border-box;
					width: 100%;
					height: 100%;
					padding: 6px 10px;
					
					p {
						height: 100%;
						overflow: hidden;
						line-height: 18px;
						font-size: 12px;
						word-break: break-all;
						white-space: pre-wrap;
					}
				}
				
				.handle {
					position: absolute;
					right: 1px;
					bottom: 1px;
					
					a {
						width: 18px;
						line-height: 18px;
						font-size: 12px;
						text-align: center;
						color: #fff;
					}
				}
			}
		}
		
		&-text-edit {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 150px;
				border: 1px solid #ddd;
				padding: 10px 14px;
				line-height: 20px;
				resize: none;
			}
		}
		
		&-table {
			width: 100%;
			
			thead {
				background: #F9F9F9;
			}
			tbody {
				background: #fff;
			}
			th, td {
				width: 100px;
				height: 40px;
				padding: 0 10px;
				line-height: 40px;
				border: 1px solid #ddd;
				color: #444;
				font-size: 12px;
				text-align: left;
			}
			
			th {
				b {
					margin-right: 5px;
					color: #f00;
				}
				
				a {
					margin-left: 5px;
				}
			}
			
			td {
				position: relative;
				
				.c-input {
					height: 30px;
					border: none;
				}
			}
		}
	}
	
	.batch-set {
		z-index: 11;
		position: fixed;
		padding: 0 11px 17px;
		margin-top: -100px;
		background: #fff;
		box-shadow: 0 0 4px 0 rgba(0,0,0,.2);
		
		p {
			line-height: 43px;
			font-size: 13px;
			font-weight: bold;
		}
		
		>>> .c-input {
			width: 100px;
			height: 30px;
			margin-right: 5px;
		}
		
		.c-button {
			height: 30px;
		}
	}
	
	.spec {
		position: relative;
		padding: 15px 17px;
		
		&:nth-child(n+2) {
			margin-top: 16px;
		}
		
		&-list {
			box-sizing: border-box;
			border: 1px dotted #ddd;
			padding: 14px;
		
			.c-button {
				margin-top: 16px;
			}
		}
		
		&-label {
			margin-right: 8px;
			line-height: 36px;
			font-size: 13px;
			white-space: nowrap;
			color: #444;
		}
		
		&-remove {
			position: absolute;
			right: 0;
			top: 0;
			width: 24px;
			line-height: 24px;
			font-size: 12px;
			text-align: center;
			color: #fff;
			background: #aaa;
			
			&:hover {
				background: #999;
			}
		}
		
		&-name {
			margin-right: 10px;
			line-height: 36px;
			font-size: 13px;
		}
		
		.c-checkbox {
			margin-top: 0;
		}
		
		&-item {
			border: 1px solid #ddd;
			padding: 5px;
			background: #fff;
			
			&.z-dis {
				background: #f5f5f5;
			}
			
			&-img {
				z-index: 1;
				position: relative;
				margin-right: 5px;
				width: 40px;
				min-width: 40px;
				height: 40px;
				color: #bbb;
				background: #fff;
				
				.main {
					height: 100%;
					cursor: pointer;
					
					&:hover {
						p {
							display: none;
						}
						
						.delete {
							display: flex;
						}
					}
					
					p {
						position: absolute;
						left: 0;
						right: 0;
						bottom: 0;
						padding: 0 5px;
						line-height: 16px;
						font-size: 12px;
						text-align: center;
						color: #fff;
						background: rgba(0,0,0,.6);
					}
					
					.delete {
						display: none;
						position: absolute;
						inset: 0;
						color: #fff;
						background: rgba(0,0,0,.6);
					}
				}
				
				.preview {
					position: relative;
					padding: 10px;
					background: rgba(0,0,0,.8);
					
					&:before {
						content: '';
						position: absolute;
						left: 14px;
						top: -6px;
						border-width: 0 6px 6px 6px;
						border-style: solid;
						border-color: rgba(0,0,0,.8) rgba(0,0,0,0);
					}
					
					&-box {
						position: absolute;
						left: 0;
						top: 100%;
						padding-top: 10px;
					}
					
					.image {
						width: 180px;
						height: 180px;
						border: none;
					}
					
					.input {
						height: 28px;
						border: none;
						margin-top: 6px;
					}
				}
			}
			
			&-value {
				width: 80px;
				height: 20px;
				font-size: 13px;
				
				&:disabled {
					cursor: not-allowed;
				}
			}
			
			&-remove {
				margin-left: 5px;
				font-size: 16px;
				color: #C70000;
			}
			
			&-drag {
				position: absolute;
				left: 100%;
				top: 0;
				width: 20px;
				line-height: 20px;
				font-size: 12px;
				text-align: center;
				background: #ddd;
			}
		}
		
		.c-button {
			margin-top: 16px;
		}
	}
	
	.sku-detail {
		position: relative;
		
		.sku-image {
			padding: 5px 0;
			
			.image {
				position: relative;
				width: 40px;
				height: 40px;
				font-size: 12px;
				cursor: pointer;
				
				&:nth-child(n+2) {
					margin-left: 5px;
				}
				
				.main {
					position: relative;
					box-sizing: border-box;
					height: 100%;
					border: 1px dotted #ccc;
					color: #ccc;
					
					&:hover {
						border-color: #999;
						color: #999;
						p {
							display: none;
						}
						
						.delete {
							display: flex;
						}
					}
					
					p {
						position: absolute;
						left: 0;
						right: 0;
						bottom: 0;
						padding: 0 5px;
						line-height: 16px;
						font-size: 12px;
						text-align: center;
						color: #fff;
						background: rgba(0,0,0,.6);
					}
					
					.delete {
						display: none;
						position: absolute;
						inset: 0;
						color: #fff;
						background: rgba(0,0,0,.6);
					}
				}
				
				.preview {
					z-index: 1;
					position: relative;
					padding: 10px;
					background: rgba(0,0,0,.8);
					
					&:before {
						content: '';
						position: absolute;
						left: 10px;
						top: -6px;
						border-width: 0 6px 6px 6px;
						border-style: solid;
						border-color: rgba(0,0,0,.8) rgba(0,0,0,0);
					}
					
					&-box {
						position: absolute;
						left: 0;
						top: 100%;
						padding-top: 10px;
					}
					
					.image {
						width: 180px;
						height: 180px;
						border: none;
					}
					
					.input {
						height: 28px;
						border: none;
						margin-top: 6px;
					}
				}
			}
		}
		
		.total {
			padding: 0 13px;
			line-height: 50px;
			font-size: 12px;
			color: #666;
			background: #F9F9F9;
		}
	}
	
	.custom-detail {
		.custom-item {
			li {
				border: 1px solid #ddd;
				padding: 0 10px;
				margin-right: -1px;
				line-height: 36px;
				font-size: 13px;
				color: #000;
				background: #fff;
				cursor: pointer;
				
				&:hover {
					position: relative;
					border-color: var(--color-main);
					color: var(--color-main);
				}
				
				&.z-crt {
					position: relative;
					border-color: var(--color-main);
					color: #fff;
					background: var(--color-main);
				}
			}
		}
		
		.detail-table {
			margin: -1px 0 12px;
			
			.position {
				padding-top: 10px;
				
				&-image {
					width: 60px;
					height: 60px;
				}
				
				p {
					line-height: 30px;
				}
			}
			
			.color {
				> div {
					border: 1px solid #eee;
					padding: 4px;
					margin-right: 6px;
					
					div {
						width: 20px;
						height: 20px;
					}
				}
			}
			.remove {
				font-size: 12px;
				color: #f00;
			}
		}
		
		.custom-option {
			padding: 10px 24px;
			
			.c-button {
				margin-bottom: 5px;
			}
			
			.position {
				border: 1px solid #eee;
				
				&-list {
					gap: 15px;
				}
				
				&-image {
					width: 120px;
					height: 120px;
					border: none;
				}
				
				&-check {
					border-top: 1px solid #eee;
					padding: 7px 8px;
					background: #FAFAFA;
				}
			}
		}
	}
</style>